import { injectQualtricsScript } from '@highmark-web/highmark-common';

const QUALTRICS_HOME_PAGE_INTERCEPTOR_ELEMENT_ID = 'ZN_0fjfph8oz8F8I2G';
const QUALTRICS_HOME_PAGE_INTERCEPTOR_COOKIE_ID = 'QSI_S_ZN_0fjfph8oz8F8I2G';
const QUALTRICS_HOME_PAGE_INTERCEPTOR_SRC =
  'https://zn0fjfph8oz8f8i2g-highmark.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_0fjfph8oz8F8I2G';

export function injectHomePageQualtricsScript() {
  injectQualtricsScript({
    elementId: QUALTRICS_HOME_PAGE_INTERCEPTOR_ELEMENT_ID,
    cookieId: QUALTRICS_HOME_PAGE_INTERCEPTOR_COOKIE_ID,
    src: QUALTRICS_HOME_PAGE_INTERCEPTOR_SRC,
  });
}
